import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { "element-loading-text": "正在获取数据，请稍后" }
const _hoisted_2 = { style: {"color":"red"} }
const _hoisted_3 = { style: {"color":"red"} }
const _hoisted_4 = { style: {"color":"red"} }
const _hoisted_5 = { style: {"color":"red"} }
const _hoisted_6 = { style: {"color":"red"} }
const _hoisted_7 = {
  key: 0,
  style: {"margin-top":"20px"}
}
const _hoisted_8 = /*#__PURE__*/_createTextVNode("审批中")
const _hoisted_9 = /*#__PURE__*/_createTextVNode("待支付")
const _hoisted_10 = /*#__PURE__*/_createTextVNode("已支付")
const _hoisted_11 = /*#__PURE__*/_createTextVNode("异常")
const _hoisted_12 = /*#__PURE__*/_createTextVNode("退回")
const _hoisted_13 = /*#__PURE__*/_createTextVNode("关闭")

import { ref, onMounted, reactive } from 'vue';
import { ElMessage } from 'element-plus';
import { GbDialog } from '@/components/GbDialog/Index';
import { PayPlanDetailApi } from '../../../apis/PayPlans/payplan.api';
import { formatTools } from '@/utils';


export default /*#__PURE__*/_defineComponent({
  setup(__props, { expose }) {

const { fAmount, fDateTime } = formatTools();
const state = reactive({
	show: false,
	load: false,
	tabActive: 0,
	detail: {} as any,
});

const laod = {
	/* 获取付款计划明细 */
	getDetail: (planId: string) => {
		state.load = true;

		PayPlanDetailApi(planId)
			.then((res) => {
				if (!res.succeeded) {
					ElMessage.error(`读取付款计划出错，可能的原因是：${res.errors}。`);
				} else {
					state.detail = res.data;
					state.tabActive = 0;
				}
			})
			.finally(() => {
				state.load = false;
			});
	},
};

/* 外部使用的方法 */
const methods = {
	/* 显示/关闭对话框 */
	showDialog: (rowId: string) => {
		laod.getDetail(rowId);
		state.show = true;
	},
};

expose({ ...methods });

return (_ctx: any,_cache: any) => {
  const _component_el_descriptions_item = _resolveComponent("el-descriptions-item")!
  const _component_el_descriptions = _resolveComponent("el-descriptions")!
  const _component_el_tag = _resolveComponent("el-tag")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_button = _resolveComponent("el-button")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createBlock(_unref(GbDialog), {
    modelValue: _unref(state).show,
    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_unref(state).show) = $event)),
    title: "付款项明细",
    style: {"width":"1000px"}
  }, {
    footer: _withCtx(() => [
      _createVNode(_component_el_button, {
        size: "small",
        type: "primary",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(state).show = false))
      }, {
        default: _withCtx(() => [
          _hoisted_13
        ]),
        _: 1
      })
    ]),
    default: _withCtx(() => [
      _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createVNode(_component_el_descriptions, {
          column: "2",
          border: true,
          size: "small"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_descriptions_item, {
              label: "合同编号",
              "label-align": "left"
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_unref(state).detail.contract_no), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_el_descriptions_item, {
              label: "合同名称",
              "label-align": "left"
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_unref(state).detail.contract_name), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_el_descriptions_item, {
              label: "合同类别",
              "label-align": "left",
              span: "2"
            }),
            _createVNode(_component_el_descriptions_item, {
              label: "我方主体",
              "label-align": "left",
              span: "2"
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_unref(state).detail.party_a), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_el_descriptions_item, {
              label: "款项名称",
              "label-align": "left",
              span: "2"
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_unref(state).detail.name), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_el_descriptions_item, {
              label: "款项条件",
              "label-align": "left",
              span: "2"
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_unref(state).detail.pay_condition), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_el_descriptions_item, {
              label: "备注",
              "label-align": "left",
              span: "2"
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_unref(state).detail.remark), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_el_descriptions_item, {
              label: "款项金额",
              "label-align": "left",
              span: "2"
            }, {
              default: _withCtx(() => [
                _createElementVNode("span", _hoisted_2, _toDisplayString(_unref(fAmount)(_unref(state).detail.amount ?? 0)), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_el_descriptions_item, {
              label: "可申请金额",
              "label-align": "left",
              span: "1"
            }, {
              default: _withCtx(() => [
                _createElementVNode("span", _hoisted_3, _toDisplayString(_unref(fAmount)(_unref(state).detail.unpay_amt ?? 0)), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_el_descriptions_item, {
              label: "待审批金额",
              "label-align": "left",
              span: "1"
            }, {
              default: _withCtx(() => [
                _createElementVNode("span", _hoisted_4, _toDisplayString(_unref(fAmount)(_unref(state).detail.audit_amt ?? 0)), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_el_descriptions_item, {
              label: "待支付金额",
              "label-align": "left",
              span: "1"
            }, {
              default: _withCtx(() => [
                _createElementVNode("span", _hoisted_5, _toDisplayString(_unref(fAmount)(_unref(state).detail.wait_amt ?? 0)), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_el_descriptions_item, {
              label: "已支付金额",
              "label-align": "left",
              span: "1"
            }, {
              default: _withCtx(() => [
                _createElementVNode("span", _hoisted_6, _toDisplayString(_unref(fAmount)(_unref(state).detail.isPay_amt ?? 0)), 1)
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        ((_unref(state).detail.bill_list || []).length > 0)
          ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
              _createVNode(_component_el_table, {
                size: "small",
                "row-key": "id",
                data: _unref(state).detail.bill_list,
                border: "",
                stripe: ""
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_table_column, {
                    prop: "pay_status",
                    label: "审批状态",
                    width: "80",
                    align: "center",
                    "header-align": "center"
                  }, {
                    default: _withCtx((props) => [
                      (props.row.pay_status == 1)
                        ? (_openBlock(), _createBlock(_component_el_tag, {
                            key: 0,
                            size: "small",
                            type: "warning"
                          }, {
                            default: _withCtx(() => [
                              _hoisted_8
                            ]),
                            _: 1
                          }))
                        : _createCommentVNode("", true),
                      (props.row.pay_status == 2)
                        ? (_openBlock(), _createBlock(_component_el_tag, {
                            key: 1,
                            size: "small",
                            type: "primary"
                          }, {
                            default: _withCtx(() => [
                              _hoisted_9
                            ]),
                            _: 1
                          }))
                        : _createCommentVNode("", true),
                      (props.row.pay_status == 3)
                        ? (_openBlock(), _createBlock(_component_el_tag, {
                            key: 2,
                            size: "small",
                            type: "success"
                          }, {
                            default: _withCtx(() => [
                              _hoisted_10
                            ]),
                            _: 1
                          }))
                        : _createCommentVNode("", true),
                      (props.row.pay_status == 4)
                        ? (_openBlock(), _createBlock(_component_el_tag, {
                            key: 3,
                            size: "small",
                            type: "danger"
                          }, {
                            default: _withCtx(() => [
                              _hoisted_11
                            ]),
                            _: 1
                          }))
                        : _createCommentVNode("", true),
                      (props.row.pay_status == 5)
                        ? (_openBlock(), _createBlock(_component_el_tag, {
                            key: 4,
                            size: "small",
                            type: "info"
                          }, {
                            default: _withCtx(() => [
                              _hoisted_12
                            ]),
                            _: 1
                          }))
                        : _createCommentVNode("", true)
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_table_column, {
                    prop: "bill_no",
                    "show-overflow-tooltip": "",
                    label: "付款单号",
                    width: "140",
                    "header-align": "center"
                  }),
                  _createVNode(_component_el_table_column, {
                    prop: "erp_bill_no",
                    "show-overflow-tooltip": "",
                    label: "金蝶申请单号",
                    width: "140",
                    "header-align": "center"
                  }, {
                    default: _withCtx((props) => [
                      _createElementVNode("span", null, _toDisplayString(props.row.erp_bill_no || '--'), 1)
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_table_column, {
                    prop: "kindee_pay_no",
                    "show-overflow-tooltip": "",
                    label: "财务付款单号",
                    width: "140",
                    "header-align": "center"
                  }, {
                    default: _withCtx((props) => [
                      _createElementVNode("span", null, _toDisplayString(props.row.kindee_pay_no || '--'), 1)
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_table_column, {
                    prop: "kindee_pay_time",
                    "show-overflow-tooltip": "",
                    label: "财务付款时间",
                    width: "140",
                    "header-align": "center"
                  }, {
                    default: _withCtx(({ row }) => [
                      _createTextVNode(_toDisplayString(_unref(fDateTime)(row.kindee_pay_time)), 1)
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_table_column, {
                    prop: "sub_emp_name",
                    label: "申请人",
                    width: "80",
                    align: "center",
                    "header-align": "center"
                  }),
                  _createVNode(_component_el_table_column, {
                    prop: "sub_emp_dept",
                    label: "申请部门",
                    width: "100",
                    align: "center",
                    "header-align": "center"
                  }),
                  _createVNode(_component_el_table_column, {
                    prop: "sub_date",
                    label: "申请时间",
                    width: "120",
                    align: "center",
                    "header-align": "center"
                  }, {
                    default: _withCtx(({ row }) => [
                      _createTextVNode(_toDisplayString(_unref(fDateTime)(row.sub_date)), 1)
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_table_column, {
                    prop: "amount",
                    label: "申请金额",
                    width: "80",
                    align: "right",
                    "header-align": "center"
                  }, {
                    default: _withCtx((props) => [
                      _createElementVNode("span", null, _toDisplayString(props.row.amount.toLocaleString('zh') || '--'), 1)
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_table_column, {
                    prop: "pay_type",
                    label: "收付款用途",
                    width: "80",
                    align: "center",
                    "header-align": "center"
                  }),
                  _createVNode(_component_el_table_column, {
                    prop: "bank_name",
                    label: "收款银行名称",
                    "show-overflow-tooltip": "",
                    width: "120",
                    "header-align": "center"
                  }),
                  _createVNode(_component_el_table_column, {
                    prop: "bank_account_name",
                    label: "收款账户名称",
                    "show-overflow-tooltip": "",
                    width: "220",
                    "header-align": "center"
                  }),
                  _createVNode(_component_el_table_column, {
                    prop: "bank_account",
                    label: "收款账户",
                    width: "180",
                    "header-align": "center"
                  }),
                  _createVNode(_component_el_table_column, {
                    prop: "pay_remark",
                    label: "付款备注",
                    "show-overflow-tooltip": "",
                    width: "300",
                    "header-align": "center"
                  })
                ]),
                _: 1
              }, 8, ["data"])
            ]))
          : _createCommentVNode("", true)
      ])), [
        [_directive_loading, _unref(state).load]
      ])
    ]),
    _: 1
  }, 8, ["modelValue"]))
}
}

})